<script lang="ts" setup>

import ButtonInput from "@/components/inputs/Button.vue";
import {ref} from "vue";
import Translator from '@/utils/common/Translator'
import NamaIcon from "@/components/icons/NamaIcon.vue";

let emit = defineEmits(['onSendResetTokenClicked']);
const EMAIL = "Email";
const PHONE_NUMBER = "Phone Number";
let codeMethod = ref(EMAIL);
let phoneOrMail = ref("");
let isPhoneOrMail = ref(true);
let validationError = ref<string>("");


function handleRadioChange(event: Event) {
  const target = event.target as HTMLInputElement;
  codeMethod.value = target.value;
}

function onContinueClick() {
  if (!validateMailOrPhone())
    return;
  emit('onSendResetTokenClicked', phoneOrMail.value, codeMethod.value === EMAIL);
}

function validateMailOrPhone(): boolean {
  isPhoneOrMail.value = Boolean(phoneOrMail.value);
  validationError.value = "";
  if (isPhoneOrMail.value && codeMethod.value === EMAIL && !isValidEmail(phoneOrMail.value)) {
    isPhoneOrMail.value = false;
    validationError.value = Translator.translate("Invalid Email")!;
    return false;
  }
  return isPhoneOrMail.value;
}

function isValidEmail(email: string): boolean {
  const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
</script>

<template>
  <div class="tw-w-full tw-h-full tw-flex tw-justify-center tw-flex-col">
    <div
      class="tw-w-1/2 tw-h-full tw-flex tw-justify-center tw-items-center tw-flex-col tw-self-center mobile:tw-w-full mobile:tw-h-auto ">
      <h4 class="tw-text-center tw-text-primary-light dark:tw-text-gray-200 tw-font-bold tw-text-4xl tw-text-nowrap tw-pb-5"
          v-text="Translator.translateId('forgotPassword')"/>
      <div class="tw-w-full tw-flex tw-flex-col tw-py-2">
        <h4 class="tw-font-bold tw-text-lg tw-mb-1.5 dark:tw-text-namaFontColor-dark">{{ Translator.translateId("selectSendCodeMethod") }}:</h4>
        <div class="tw-w-full tw-flex tw-justify-between">
          <div class="tw-flex tw-flex-grow tw-items-center">
            <input id="email-code-method" :checked="codeMethod==EMAIL" :value="EMAIL" class="focus:tw-ring-0 focus:tw-ring-offset-0" name="send-code-method"
                   type="radio" @input="handleRadioChange">
            <label class="tw-ms-1 tw-text-md tw-font-bold dark:tw-text-namaFontColor-dark" for="email-code-method">{{ Translator.translateId("Email") }}</label>
          </div>
          <div class="tw-flex tw-flex-grow tw-items-center">
            <input id="phone-code-method" :checked="codeMethod==PHONE_NUMBER" :value="PHONE_NUMBER" class="focus:tw-ring-0 focus:tw-ring-offset-0"
                   name="send-code-method"
                   type="radio" @input="handleRadioChange">
            <label class="tw-ms-1 tw-text-md tw-font-bold  focus:tw-outline-none dark:tw-text-namaFontColor-dark" for="phone-code-method">{{ Translator.translateId("phoneNumber") }}</label>
          </div>
        </div>
      </div>
      <div class="tw-w-full tw-flex tw-flex-col">
        <q-input
          outlined
          input-class="nama-input-class"
          class="nama-customize-dense-input nama-focused-input nama-field-input"
          :class="{'tw-border-red-600': !isPhoneOrMail}"
          v-model="phoneOrMail"
          :placeholder="codeMethod==EMAIL?Translator.translateId('Email'):Translator.translateId('phoneNumber')"
          :error="!isPhoneOrMail"
          @keyup.enter="onContinueClick">
          <template v-slot:prepend>
            <NamaIcon v-if="codeMethod==EMAIL" default-icon="nm-email"/>
            <NamaIcon v-if="codeMethod==PHONE_NUMBER" default-icon="nm-phone_call_3059408"/>
          </template>
        </q-input>
        <ButtonInput :text="Translator.translateId('Continue')" @click="onContinueClick" @keydown.enter="onContinueClick"/>
      </div>
    </div>
  </div>
</template>
